import { MessageTypeEnum } from "./MessageModel";
import { Timestamp } from "firebase/firestore";

export class ChatModel {
  authorized: boolean;
  companyId: string;
  phoneNumber?: string;
  fullName?: string;
  displayName?: string;
  profileName?: string;
  customName?: string;
  profilePictureUrl?: string;
  waId?: string;
  whatsappUserId?: string;
  whatsappUsername?: string;
  notes?: string;
  tags: string[];
  maposUser?: {
    fullName?: string;
  };
  serviceActive?: string;
  closedAt?: Date;
  // maposOrder?: MaposOrderModel
  // maposUser?: MaposUserDTO
  // invoiceData?: MaposFECustomerDTO
  // addressOrder?: MaposAddressDTO
  // storeOrder?: MaposStoreDTO
  lastMessage?: string;
  lastMessageType?: MessageTypeEnum;
  lastMessageDate?: Date;
  lastMessageRole?: string;
  lastInboundMessageDate?: Date;
  dateToProgram?: number;
  createdAt: Date;
  updatedAt: Date;
  botIsEnabled: boolean;
  isTestReplay?: boolean;
  supportPending?: boolean;
  hasSupportTicket?: boolean;
  supportTicketCode?: string;
  supportReason?: string;
  channel: string;

  constructor(data: any, id?: string) {
    this.authorized = data.authorized ?? false;
    this.phoneNumber = data.phoneNumber || id;
    this.companyId = data.companyId;
    this.fullName = data.fullName;
    this.displayName = data.displayName;
    this.profileName = data.profileName;
    this.customName = data.customName;
    this.profilePictureUrl = data.profilePictureUrl;
    this.waId = data.waId;
    this.whatsappUserId = data.whatsappUserId;
    this.whatsappUsername = data.whatsappUsername;
    this.notes = data.notes;
    this.tags = Array.isArray(data.tags) ? data.tags : [];
    this.maposUser = data.maposUser;
    this.serviceActive = data.serviceActive;
    this.closedAt = (data.closedAt as Timestamp)?.toDate();
    // this.maposOrder = data.maposOrder
    // this.maposUser = data.maposUser
    // this.invoiceData = data.invoiceData
    // this.addressOrder = data.addressOrder
    // this.storeOrder = data.storeOrder
    this.lastMessage = data.lastMessage;
    this.lastMessageType = data.lastMessageType || undefined;
    this.lastMessageDate = (data.lastMessageDate as Timestamp)?.toDate();
    this.lastMessageRole = data.lastMessageRole;
    this.lastInboundMessageDate = (data.lastInboundMessageDate as Timestamp)?.toDate();
    this.dateToProgram = data.dateToProgram;
    this.createdAt = (data.createdAt as Timestamp)?.toDate();
    this.updatedAt = (data.updatedAt as Timestamp)?.toDate();
    this.botIsEnabled = data.botIsEnabled ?? true;
    this.isTestReplay = data.isTestReplay === true;
    this.supportPending = data.supportPending === true;
    this.hasSupportTicket = data.hasSupportTicket === true;
    this.supportTicketCode = data.supportTicketCode;
    this.supportReason = data.supportReason;
    this.channel =
      data.channel ||
      data.chatType ||
      data.platform ||
      data.source ||
      "whatsapp";
  }
}
